
import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IChingService } from './i-ching.service';
import { MaterialModule } from 'jk-service';
import { MatTabGroup } from '@angular/material/tabs';
import { idNameItem } from 'jk-service';
import { MarkdownComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { Jcktl005List, SexList } from '../_service_jck';
import { CommonModule } from '@angular/common';

/** 易經卜卦 元件 — 包含 wizard 步驟控制 */
@Component({
  selector: 'app-i-ching',
  standalone: true,
  imports: [FormsModule, CommonModule, JackBaseComponentModule, MaterialModule, MarkdownComponent],
  templateUrl: './i-ching.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './i-ching.component.css'
})
export class IChingComponent {
  @ViewChild('masterTabGroup') masterTabGroup!: MatTabGroup;

  jcktl005List: idNameItem[] = Jcktl005List;
  sexList: idNameItem[] = SexList;

  /** wizard 步驟標籤清單 */
  steps: string[] = ['基本資料', '取卦方式', '卦象結果', '記錄'];

  constructor(public ic: IChingService) {}

  ngAfterViewInit() {
    this.ic.jcktl005 = this.jcktl005List[0].id;
    this.ic.masterTabGroup = this.masterTabGroup;
    this.ic.question = '我最近運勢如何?';
  }

  /** 跳至指定步驟 */
  goToStep(step: number) {
    this.ic.currentStep = step;
  }

  /** 下一步 */
  nextStep() {
    if (this.ic.currentStep < this.steps.length - 1) {
      this.ic.currentStep++;
    }
  }

  /** 上一步 */
  prevStep() {
    if (this.ic.currentStep > 0) {
      this.ic.currentStep--;
    }
  }

  /** 執行計算（自動三位數後計算）*/
  doCalculate() {
    this.ic.doHandInput();
  }

  /** 自行輸入上下卦後計算 */
  doManualInput() {
    this.ic.loadDocument();
    this.ic.doAnswer();
    this.ic.calculated = true;
    this.ic.currentStep = 2;
    this.ic.doAIPrompt();
  }
}
